import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import * as Styles from '../styles';

interface IProps {
    onClick: () => void;
}

const FailureV1: React.FC<IProps> = (props) => {
    const { onClick } = props;
    return (
        <Styles.Wrapper>
            <Styles.TextBlock>Sorry 😔</Styles.TextBlock>
            <Styles.SubTextBlock>
                Unfortunately, the payment to Acko has failed and plan hasn
                &apos;t been issued. Please retry the transaction again
            </Styles.SubTextBlock>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/payment_failure.svg')}
                />
            </Styles.Banner>
            <Styles.GoHomeButtonWrapper>
                <PrimaryButton onClick={onClick}>
                    Retry the transaction
                </PrimaryButton>
            </Styles.GoHomeButtonWrapper>
        </Styles.Wrapper>
    );
};

export default FailureV1;
